module.exports = __webpack_public_path__ + "static/media/mcm_3201.a44da92c.ico";